import React, { useEffect, useState } from "react";
import { Box, Typography, Card, CircularProgress , useMediaQuery, IconButton,} from "@mui/material";
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import Rating from "@mui/material/Rating";
import commentsStyles from "./commentsStyle";
import { useTheme } from "@emotion/react";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";

const CommentsSection = () => {
    const classes = commentsStyles();
    const [comments, setComments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentIndex, setCurrentIndex] = useState(0);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    useEffect(() => {
         // Fetching comments from MongoDB- backend
               fetch("https://pakethorizons.ddns.net/api/feedback") // Fetching from backend
            .then((response) => response.json())
            .then((data) => {

                // Take only the last 3 comments
                setComments(data.slice(0, 3));
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching comments:", error);
                setLoading(false);
            });
    }, []);

    //handle next button in mobile view
    const handleNext = () => {
        if (currentIndex < comments.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    };
    //handle back button in mobile view
    const handlePrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    return (
        <Box className={classes.container}>

             {/* Title */}
            <Typography variant="h4" className={classes.title}>
                What Our Users Say
            </Typography>

             {/* Paragraph */}
            <Typography variant="body1" className={classes.paragraph}>
                Check what other users are saying about about our Web app and Interactive viewers!
            </Typography>

            {loading ? (
                <CircularProgress />
            ) : (
                <Box className={classes.commentsContainer}>
                {isMobile ? (
                    <Box className={classes.mobileCommentWrapper}>
                        {/* Left Navigation Button- Mobile view */}
                        <IconButton
                            className={`${classes.navButton} ${currentIndex === 0 ? classes.disabledButton : ""}`}
                            onClick={handlePrev}
                            disabled={currentIndex === 0}
                        >
                            <ArrowBackIos />
                        </IconButton>

                        {/* Display Single Comment- Mobile view */}
                        <Card key={currentIndex} className={classes.commentCard}>
                            <FormatQuoteIcon className={classes.quoteIcon} />
                            <Typography className={classes.commentText}>
                                "{comments[currentIndex].additionalComments}"
                            </Typography>
                            <Box className={classes.ratingContainer}>
                                <Rating
                                    value={comments[currentIndex].usability}
                                    readOnly
                                    precision={0.5}
                                    sx={{ color: "#FFA726" }}
                                />
                            </Box>
                            <Box>
                                <Typography className={classes.userName}>
                                    {comments[currentIndex].firstName} {comments[currentIndex].lastName}
                                </Typography>
                            </Box>
                        </Card>

                        {/* Right Navigation Button (Disabled on Last Comment) */}
                        <IconButton
                            className={`${classes.navButton} ${currentIndex === comments.length - 1 ? classes.disabledButton : ""}`}
                            onClick={handleNext}
                            disabled={currentIndex === comments.length - 1}
                        >
                            <ArrowForwardIos />
                        </IconButton>
                    </Box>
                ) : (
                    /* Show Multiple Comments in Desktop View */
                    <Box className={classes.desktopComments}>
                        {comments.slice(0, 3).map((comment, index) => (
                            <Card key={index} className={classes.commentCard}>

                                {/* Quote Icon */}
                                <FormatQuoteIcon className={classes.quoteIcon} />

                                {/* Comment Text */}
                                <Typography className={classes.commentText}>
                                    "{comment.additionalComments}"
                                </Typography>

                                {/* ⭐ Display Usability Rating Before Name */}
                                <Box className={classes.ratingContainer}>
                                    <Rating
                                        value={comment.usability}
                                        readOnly
                                        precision={0.5}
                                        sx={{ color: "#FFA726" }}
                                    />
                                </Box>

                                <Box>
                                    <Typography className={classes.userName}>
                                        {comment.firstName} {comment.lastName}
                                    </Typography>
                                </Box>
                            </Card>
                        ))}
                    </Box>
                )}
                </Box>
            )}
        </Box>
    );
};

export default CommentsSection;
